import Crud from '../views/RejectionType/Crud'
import Entity from '../views/RejectionType/Add'

let routes = {
    path: '/rejection_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/rejection_types/add',
            name: 'NewRejectionType',
            component: Entity,
            meta: {
                pageTitle: 'rejectionType.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'rejectionType.form.titleNew',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/rejection_types/edit/:id?',
            name: 'EditRejectionType',
            component: Entity,
            meta: {
                pageTitle: 'rejectionType.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'rejectionType.form.titleEdit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/rejection_types',
            name: 'list-rejection-types',
            component: Crud,
            meta: {
                pageTitle: 'rejectionType.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'rejectionType.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
